import { frontendURL } from '../../../../helper/URLHelper';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import SettingsWrapper from '../SettingsWrapper.vue';
import Invoices from './Invoices.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/billing/invoices'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      props: {
        headerTitle: 'BILLING_SETTINGS.INVOICES',
        icon: 'credit-card-person',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'billing_settings_invoices',
          component: Invoices,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
